import React from 'react';
import './Theory.css';
import { theorySections } from '../data/theorySections';

const Theory: React.FC = () => {
  return (
    <section className="theory-section">
      <div className="container">
        <h1 className="page-title">Taekwon-Do Theory</h1>
        <p className="page-subtitle">
          Reference material on the traditions, terminology and techniques of ITF Taekwon-Do
        </p>

        <div className="theory-content">
          {theorySections.map((section) => (
            <div key={section.id} className="content-section">
              <h2 id={section.id}>{section.title}</h2>
              {section.content}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Theory;
